export const replaceWhitespacesWithNbsp = (s: string): string => {
  return s.replace(/\s/g, "\u00A0");
};

export const numbersWithDotSeparator = (s: string): string => {
  const splittedValue = s.split(".");
  return splittedValue[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};
